// import AWSCredential from "@/types/AWSCredential";
import { InjectionKey } from "vue";
import { createStore, Store, useStore as baseUseStore } from "vuex";
import authModule from "@/store/auth/index";

type State = {
  items: any;
  isOpen: any;
  isSubMenuOpen: any;
  isAltLogin: boolean;
  isAltLogout: boolean;
  oriLoginUserInfo: any;
  accessLog: any;
};

export const key: InjectionKey<Store<State>> = Symbol();

export const store = createStore<State>({
  state() {
    return {
      items: [],
      isOpen: [],
      isSubMenuOpen: [],
      isAltLogin: false,
      isAltLogout: false,
      oriLoginUserInfo: [],
      accessLog: []
    };
  },
  mutations: {
    setItems(state: { items: any[]; }, payload: any) {
      state.items.push(payload);
    },
    setIsOpen(state: { isOpen: any[]; }, payload: any) {
      state.isOpen.push(payload);
    },
    setIsSubMenuOpen(state: { isSubMenuOpen: any[]; }, payload: any) {
      state.isSubMenuOpen.push(payload);
    },
    setIsAltLogin(state: { isAltLogin: boolean; }, payload: any) {
      state.isAltLogin = payload
    },
    setIsAltLogout(state: { isAltLogout: boolean; }, payload: any) {
      state.isAltLogout = payload
    },
    setFirstMostUserData() {
      store.state.oriLoginUserInfo.splice(0);
      const firstmostUserData = {
            userId: store.getters.cognitoUserName,
            email: store.getters.email,
            givenName: store.getters.givenName,
            familyName: store.getters.familyName,
            stationCode: store.getters.stationCode,
            companyName: store.getters.companyName,
            department: store.getters.department,
            title: store.getters.title,
            loginNumber: store.getters.loginNumber,
            isAlterLoginAdmin: store.getters.isAltLoginAdmin
          };
      store.state.oriLoginUserInfo.push(firstmostUserData);
      store.state.items.splice(0);
      store.state.isOpen.splice(0);
      store.state.isSubMenuOpen.splice(0);
    },
    setAccessLog(state: { accessLog: any[]; }, payload: any) {
      state.accessLog.push(payload);
    },
    setReturnFirstMostUserData() {
      store.state.items.splice(0);
      store.state.isOpen.splice(0);
      store.state.isSubMenuOpen.splice(0);
      store.state.accessLog.splice(0);

      const oriUserObj = store.state.oriLoginUserInfo;
      store.dispatch("setUsername", oriUserObj[0].userId);
      store.dispatch("setEmail", oriUserObj[0].email);
      store.dispatch("setGivenName", oriUserObj[0].givenName);
      store.dispatch("setFamilyName", oriUserObj[0].familyName);
      store.dispatch("setStationCode", oriUserObj[0].stationCode);
      store.dispatch("setLoginNumber", oriUserObj[0].loginNumber);
      store.dispatch("setCompanyName", oriUserObj[0].companyName);
      store.dispatch("setTitle", oriUserObj[0].title);
      store.dispatch("setDepartment", oriUserObj[0].department);
      store.dispatch("setIsAltLoginAdmin", oriUserObj[0].isAlterLoginAdmin);
    }
  },
  actions: {
    setItems(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setItems", payload);
    },
    setIsOpen(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setIsOpen", payload);
    },
    setIsSubMenuOpen(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setIsSubMenuOpen", payload);
    },
    setIsAltLogin(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setIsAltLogin", payload);
    },
    setIsAltLogout(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setIsAltLogout", payload);
    },
    setFirstMostUserData(context: { commit: (arg0: string) => void; }) {
      context.commit("setFirstMostUserData");
    },
    setAccessLog(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setAccessLog", payload);
    },
    setReturnFirstMostUserData(context: { commit: (arg0: string) => void; }) {
      context.commit("setReturnFirstMostUserData");
    },
  },
  modules: {
    authModule,
  },
});

export const useStore = (): Store<State> => {
  return baseUseStore(key);
};
